import { Component, OnInit } from '@angular/core';
import { ProductComponent} from '../../components/product/product.component';

@Component({
  selector: 'app-product-page',
  templateUrl: './booking-products.component.html',
  styleUrls: ['./booking-products.component.css'],
})
export class BookingProductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
